import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, useApi } from "../api";
import { PageShell } from "../components/Layout";
import { Reveal, Marquee, SpotlightCard } from "../components/Motion";
import Seo from "../components/Seo";
import { PageHero, Loading } from "../components/Sections";

export default function Sectors() {
  const { data, loading } = useApi(api.sectors, []);

  return (
    <PageShell>
      {loading || !data ? (
        <Loading />
      ) : (
        <>
          <Seo title={data.title} description={data.description} path="/sectors" />
          <PageHero
            eyebrow="SECURITY BY SECTOR // 9 INDUSTRIES"
            lines={["INDUSTRY", "SECURITY", "SPECIALISTS"]}
            intro={[
              "Every industry has its own threat profile, regulations and culture. Xtreme Protection builds sector-specific security programmes — officers trained for your environment, briefed on your risks, and supervised against your industry's standards.",
              "Select your sector to see how we protect it, the services deployed most often, and the locations we cover.",
            ]}
            breadcrumb={[{ label: "Home", path: "/" }, { label: "Sectors", path: "/sectors" }]}
          />
          <Marquee items={data.sectors.map((s) => `${s.name} Security`)} />
          <section className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="sectors-index">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {data.sectors.map((s, i) => (
                <Reveal key={s.slug} delay={(i % 3) * 0.06}>
                  <Link to={`/sectors/${s.slug}`} data-testid={`sector-card-${s.slug}`} className="block h-full group">
                    <SpotlightCard className="h-full overflow-hidden hover:border-amber/60 transition-colors duration-300 flex flex-col">
                      <div className="relative h-44 overflow-hidden">
                        <img
                          src={s.image}
                          alt={`${s.name} security`}
                          loading="lazy"
                          className="w-full h-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent" />
                        <span className="absolute top-4 left-4 font-mono text-[10px] text-amber tracking-widest">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                      </div>
                      <div className="p-6 flex flex-col flex-1">
                        <h3 className="font-display font-bold uppercase tracking-wide text-xl text-white group-hover:text-amber transition-colors leading-tight">
                          {s.name}
                        </h3>
                        <p className="mt-3 text-xs sm:text-sm text-gray-400 leading-relaxed flex-1">{s.blurb.slice(0, 140)}…</p>
                        <div className="mt-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-amber">
                          Explore sector <ArrowUpRight className="w-3.5 h-3.5" />
                        </div>
                      </div>
                    </SpotlightCard>
                  </Link>
                </Reveal>
              ))}
            </div>
          </section>
        </>
      )}
    </PageShell>
  );
}
